/* istanbul ignore file @preserve */
import { createPinia } from 'pinia'

export const pinia = createPinia()
